import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { CurrencyProvider } from './contexts/CurrencyContext';
import SalesLanding from './pages/SalesLanding';
import Checkout from './pages/Checkout';
import TestSelection from './pages/TestSelection';
import Assessment from './pages/Assessment';
import Results from './pages/Results';
import Login from './pages/Login';
import Register from './pages/Register';
import ThankYou from './pages/ThankYou';
import AdminLogin from './pages/AdminLogin';
import UserDashboard from './pages/UserDashboard';
import AdminDashboard from './pages/AdminDashboard';
import DuoReport from './pages/DuoReport';
import LegalNotices from './pages/LegalNotices';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import NotFound from './pages/NotFound';
import CookieBanner from './components/CookieBanner';
import Analytics from './components/Analytics';
import SEOHead from './components/SEOHead';
import './App.css';

// Protected route wrapper for users
const ProtectedUserRoute = ({ children }) => {
  const token = localStorage.getItem('bpm_access_token');
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

// Protected route wrapper for admins
const ProtectedAdminRoute = ({ children }) => {
  const token = localStorage.getItem('bpm_admin_token');
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};

function App() {
  return (
    <LanguageProvider>
      <CurrencyProvider>
        <SEOHead />
        <Analytics />
        <div className="App">
          <BrowserRouter>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<SalesLanding />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register/:token" element={<Register />} />
              <Route path="/merci" element={<ThankYou />} />
              <Route path="/admin/login" element={<AdminLogin />} />

              {/* Legal Pages */}
              <Route path="/cgv" element={<Terms />} />
              <Route path="/mentions-legales" element={<LegalNotices />} />
              <Route path="/privacy" element={<Privacy />} />

              {/* Protected User Routes */}
              <Route path="/dashboard" element={
                <ProtectedUserRoute>
                  <UserDashboard />
                </ProtectedUserRoute>
              } />
              <Route path="/tests" element={
                <ProtectedUserRoute>
                  <TestSelection />
                </ProtectedUserRoute>
              } />
              <Route path="/test/:testId" element={
                <ProtectedUserRoute>
                  <Assessment />
                </ProtectedUserRoute>
              } />
              <Route path="/results" element={
                <ProtectedUserRoute>
                  <Results />
                </ProtectedUserRoute>
              } />
              <Route path="/duo/:duoLinkId" element={
                <ProtectedUserRoute>
                  <DuoReport />
                </ProtectedUserRoute>
              } />

              {/* Protected Admin Routes */}
              <Route path="/admin" element={
                <ProtectedAdminRoute>
                  <AdminDashboard />
                </ProtectedAdminRoute>
              } />

              {/* Legacy routes - keep working */}
              <Route path="/test-selection/:assessmentId" element={<TestSelection />} />
              <Route path="/assessment/:assessmentId" element={<Assessment />} />
              <Route path="/results/:assessmentId" element={<Results />} />

              {/* 404 */}
              <Route path="*" element={<NotFound />} />
            </Routes>
            <CookieBanner />
          </BrowserRouter>
        </div>
      </CurrencyProvider>
    </LanguageProvider>
  );
}

export default App;
